<template>
  <v-stepper-content step="4">
    <v-row>
      <v-col>
        <v-text-field
          v-model="name"
          label="Name"
        ></v-text-field>
        <v-text-field
          v-model="cameraModel"
          label="Camera model"
          disabled
        ></v-text-field>
        <v-text-field
          v-model="cameraSerial"
          label="Camera serial"
          disabled
        ></v-text-field>
        <v-text-field
          v-model="cameraFirmware"
          label="Camera firmware"
          disabled
        ></v-text-field>
      </v-col>
      <v-col>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-btn class="ma-3" rounded @click="$emit('update:e1', 3)">Back</v-btn>
      <v-btn
        class="ma-3"
        color="primary"
        @click="ready"
        rounded
        :disabled="!(name)"
      >
        ready
      </v-btn>
    </v-row>
  </v-stepper-content>
</template>
<script>
/* eslint no-fallthrough: "off" */

import gql from 'graphql-tag';

const UPDATE_DEVICE_PROPERTIES = gql`
mutation user_update_device($id: String!, $name: String, $description: String) {
  update_devices_by_pk(
    pk_columns: { id: $id },
    _set: {
      name: $name,
      description: $description
    }
  ){
    id
    serial
    firmware
    name
    description
  }
}
`;
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      name: null,
    };
  },
  computed: {
    cameraModel() {
      return this.$store.state.cameraModel;
    },
    cameraFirmware() {
      return this.$store.state.cameraFirmware;
    },
    cameraSerial() {
      return this.$store.state.cameraSerial;
    },
  },
  methods: {
    ready() {
      const id = this.$store.state.cameraId;
      let route = null;
      switch (this.type) {
        case 'camera':
          route = { name: 'Cameras' };
          break;
        case 'mobile':
          route = { name: 'Mobiles' };
          break;
        case 'headset':
          route = { name: 'Headsets' };
          break;
        default:
          console.error('device type unknown');
      }

      this.$apollo.mutate({
        mutation: UPDATE_DEVICE_PROPERTIES,
        variables: {
          id,
          name: this.name.trim(),
          description: this.cameraModel,
        },
        // eslint-disable-next-line
        update: (cache, { data: { update_devices_by_pk } }) => {
          // Read the data from our cache for this query.
          // eslint-disable-next-line
          // TODO error handling. What IF mutation doesn't work
          if (route) {
            this.$router.replace(route);
          }
        },
      });
    },
  },
};
</script>
